import FeaturesContainer from './FeaturesContainer';

const PlatformSupport = ({ history }) => {
	return (
		<FeaturesContainer
			history={history}
			pageName={'platform-support'}
			nextUrl={'signup'}
			pageEvent={'onboardingPlatformsShown'}
			clickEvent={'onboardingPlatformsSubmitted'}
		/>
	);
};

export default PlatformSupport;
